import React from 'react'

// App-wide safety net: if any component throws during render, React unmounts the
// whole tree and the user sees a blank white page. This catches that and shows a
// recoverable fallback instead.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('Render error caught by ErrorBoundary:', error, info)
  }

  handleReload = () => {
    this.setState({ hasError: false })
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-print-none" style={{ padding: '2rem', textAlign: 'center' }}>
          <h3>Terjadi kesalahan saat memuat halaman</h3>
          <p>Silakan muat ulang halaman. Jika masalah berlanjut, coba masuk kembali.</p>
          <div className="d-flex justify-content-center" style={{ gap: '0.5rem' }}>
            <button className="btn btn-primary" onClick={this.handleReload}>
              Muat Ulang
            </button>
            <a className="btn btn-outline-secondary" href="/login">
              Masuk Kembali
            </a>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
